import React, { useState } from 'react'
import PedidosYaStyle from '../../../../assets/css/components/admin/plugins/PedidosYaStyle';
import Navbar from './Navbar';
import Campaign from './Campaign';
import CampaignList from './CampaignList';

export default function GlobalCampaign({name, sendCampaignFn, deleteCampaignFn, getListFn}) {
    const [currentStep, setCurrentStep] = useState(0);

    const renderStep = () => {
        switch (currentStep) {
            case 0:
                return (<Campaign name={name} sendCampaignFn={sendCampaignFn}/>)
            case 1:
                return (<CampaignList setCurrentStep={setCurrentStep} deleteCampaignFn={deleteCampaignFn} getListFn={getListFn}/>)
            default:
                return (<CampaignList deleteCampaignFn={deleteCampaignFn} getListFn={getListFn}/>);
        }
    }

    return (
        <PedidosYaStyle.Cont>
            <PedidosYaStyle.Header>
                <PedidosYaStyle.Text size="15pt" fw="500">
                    Campañas de {name}
                </PedidosYaStyle.Text>
            </PedidosYaStyle.Header>
            <Navbar currentStep={currentStep} setCurrentStep={setCurrentStep} />
            <PedidosYaStyle.ContStep>
                {renderStep()}
            </PedidosYaStyle.ContStep>
        </PedidosYaStyle.Cont>
    )
}